import { getWelcomeText } from "../../welcome";
import { DISCLAIMER } from "../../../../global/variables";
import {
    ALG_LANDING_PAGE,
    BGELD_FREE_TEXT,
    KIN_FREE_TEXT,
    KIZ_FREE_TEXT,
    KUG_FREE_TEXT,
    SAS_FREE_TEXT,
    STARTSEITE_BUTTONS,
} from "../../../feature-buttons";

export const startseiteDZTconfig = {
    text: getWelcomeText("STARTSEITE"),
    disclaimer: DISCLAIMER,
    additionalContent: {
        firstText: "",
        buttons: [
          {
            text: "Arbeitslosengeld und weitere Themen",
            botId: ALG_LANDING_PAGE.botId,
            message: ALG_LANDING_PAGE.message,
            mesosId: ALG_LANDING_PAGE.mesosId,
          },
          {
            text: "Bürgergeld",
            botId: BGELD_FREE_TEXT.botId,
            message: BGELD_FREE_TEXT.message,
            mesosId: BGELD_FREE_TEXT.mesosId,
          },
          {
            text: "Kindergeld",
            botId: KIN_FREE_TEXT.botId,
            message: KIN_FREE_TEXT.message,
            mesosId: KIN_FREE_TEXT.mesosId,
          },
          {
            text: "Kinderzuschlag",
            botId: KIZ_FREE_TEXT.botId,
            message: KIZ_FREE_TEXT.message,
            mesosId: KIZ_FREE_TEXT.mesosId,
          },
          {
            text: "Kurzarbeitergeld",
            botId: KUG_FREE_TEXT.botId,
            message: KUG_FREE_TEXT.message,
            mesosId: KUG_FREE_TEXT.mesosId,
          },
          {
            text: "Ausbildung, Studium & Berufe",
            botId: SAS_FREE_TEXT.botId,
            message: SAS_FREE_TEXT.message,
            mesosId: SAS_FREE_TEXT.mesosId,
          },
        ],
        secondText: "",
    },
    buttons: STARTSEITE_BUTTONS,
};
